import { portalApi } from "../../../services/api";

export async function fetchNoticias({ idEvento, pageSize = 6 }) {
  const res = await portalApi.get("noticia", {
    params: {
      flag_del: 0,
      id_estabelecimento: 1,
      "eventos.id_evento": idEvento,
      sort: "-created_at",
      pageSize,
    },
  });

  if (res.data._meta.totalCount === 0) {
    return [];
  }

  return res.data.items;
}
